module.exports = __webpack_public_path__ + "img/joinus-9.bbe9c00f.png";